/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.levels.create.modals.remove.controllers', [
  'ui.bootstrap'
])

.controller('MembershipLevelsCreateModalsRemoveController', ['$scope', '$uibModalInstance', 'currentLevel', function($scope, $uibModalInstance, currentLevel) {

    $scope.membershipLevelsCreateModalsRemove = {

      model: {},

      init: function() {
        if (currentLevel) {
          this.model = currentLevel;
        }
      },

      done: function() {
        $uibModalInstance.close(true);
      },

      cancel: function() {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipLevelsCreateModalsRemove.init();

}]);